import { Transaction } from './../dto/transaction/transaction';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class TransactionService {
  constructor(private http: HttpClient) {
  }

  get(page: number, size: number, dataFilter : Transaction, sortCol: string, sortDir: string ): Observable<any> {
    let params = new HttpParams().append('page', page.toString()).append('size', size.toString())
    .append('sortCol', sortCol.toString()).append('sortDir', sortDir.toString());
    if(dataFilter) {
      Object.keys(dataFilter).forEach(item => {
        params = params.append(item.toString(), dataFilter[item]?.toString() || '')
      })
    }

    return this.http.get(environment.apiUrl + '/dashboard/transaction', { params: params}).pipe(map(data => data));
  }

  getById(transaction_id: string) : Observable<any> {
    return this.http.get(environment.apiUrl + '/dashboard/transaction/'+transaction_id,).pipe(map(data => data));
  }
}
